// Module
var code = "<mx-modal> <mx-modal-header> Session Timeout Warning </mx-modal-header> <mx-modal-body> Your session will expire due to inactivity {{ SessionTimeout.timeRemaining }} seconds. </mx-modal-body> </mx-modal> ";
// Exports
var _module_exports = code;;
var path = '@collectivehealth/frontend-member-v2/components/sessionTimeout/sessionTimeout.html';
var angular = require('angular');
angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;